// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui'
import VueQriously from 'vue-qriously'
import axios from 'axios'
import {get,post} from './utils/http'
import storage from './utils/storage'
import validate from './utils/validate'
import global from './utils/global'

import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/dist/css/swiper.css'

// import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/css/main.css'
import '@/assets/styles/css/client.css'
import '@/assets/styles/scss/common.scss'
// 默认会找 Filters/index.js
import * as filters from './filters/'
 
Vue.config.productionTip = false
// Vue.config.devtools = true;

// Vue.use(ElementUI)
Vue.use(VueQriously)

//定义全局变量
Vue.prototype.$axios = axios
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$storage = storage
Vue.prototype.$validate = validate
Vue.prototype.$global = global
Vue.prototype.$swiper = Swiper

// 遍历所有导出的过滤器并添加到全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
})

// 路由匹配
router.beforeEach((to,from,next) => {
  if (to.matched.length === 0) {
    next('/404');
  } else {
    next(); 
  }

});
// 跳转后返回顶部
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js